import styled from "styled-components";

export const DiscoverMoreStyled = styled.button`
  border: 1px solid ${({ theme }) => theme.COLORS.PURPLE_1};
  border-radius: 32px;
  padding: 11px 11px 11px 32px;
  display: flex;
  align-items: center;
  gap: 31px;
  background: none;
  cursor: pointer;
  &:hover {
    border-color: ${({ theme }) => theme.COLORS.PURPLE_10};
    background: ${({ theme }) => theme.COLORS.PURPLE_10};
    .text {
      color: ${({ theme }) => theme.COLORS.WHITE_1};
    }
    svg {
      circle {
        stroke: ${({ theme }) => theme.COLORS.WHITE_1};
      }
      path {
        fill: ${({ theme }) => theme.COLORS.WHITE_1};
      }
    }
  }
  .text {
    color: ${({ theme }) => theme.COLORS.PURPLE_1};
    font-size: ${({ theme }) => theme.FONT.SIZE.S14};
    font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_MEDIUM};
  }
`;
